import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AppGateService {
    private get ua(): string {
        return navigator.userAgent || '';
    }

    get isAndroid(): boolean {
        return /Android/i.test(this.ua);
    }

    get isIOS(): boolean {
        const ua = this.ua;

        const iosDevice =
            /iPhone|iPad|iPod/i.test(ua);

        const iPadOS13Plus =
            navigator.platform === 'MacIntel' &&
            navigator.maxTouchPoints > 1;

        return (iosDevice || iPadOS13Plus) && !this.isAndroid;
    }

    get isMobile(): boolean {
        return this.isIOS || this.isAndroid;
    }
}